export const FM_SMART_BLOCK_CATEGORIES = [
  'Patient & Identity',
  'Insurance & Documents',
  'Medical & Dental History',
  'Consent & Authorization',
  'Signatures',
  'Policy & Communication',
] as const;

export const FM_BUILDER_CANVAS_WIDTH = {
  narrow: 640,
  regular: 720,
  wide: 820,
} as const;

export type FormBuilderCanvasSize = keyof typeof FM_BUILDER_CANVAS_WIDTH;

export const FM_BUILDER_VIEWPORT_WIDTH = {
  desktop: FM_BUILDER_CANVAS_WIDTH.regular,
  tablet: 600,
  mobile: 390,
} as const;
